import * as _ from 'lodash'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { faCircleNotch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

import { Container } from '@skinsoft/types'
import { containerSelectors, locationSelectors } from '@skinsoft/selectors'
import { ContainerDataStore } from '@skinsoft/entity/src/container'
import { LocationDataStore } from '@skinsoft/entity/src/location'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { EntityFeaturedCard, LocalizedString } from '@skinsoft/ui'
import { toFeatured$ } from '../../serializer/featured'
import { DELETE_CARD } from '@skinsoft/events'

const MONGO_ID_REGEX = /^[a-f\d]{24}$/i

@Component({
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
        sLocalizedString: LocalizedString,
    },
    props: ['featured'],
    template: require('./container-featured-card.html'),
})
export class ContainerFeaturedCard extends ReactiveVue {
    public $containerDataStore: ContainerDataStore
    public $locationDataStore: LocationDataStore
    public serializer = toFeatured$

    private featured: Container
    private locationPath: string = ''
    private futureLocationPath: string = ''

    private isBeingDeleted = false
    private deleting = false

    public checkIcon = faCheck
    public crossIcon = faTimes
    public circleNotchIcon = faCircleNotch

    private mounted() {
        this.fillLocation()
    }

    private fillLocation() {
        this.futureLocationPath = containerSelectors.futureLocation(this.featured, this.$i18n.locale)
        this.locationPath = containerSelectors.location(this.featured, this.$i18n.locale)
        if(this.locationPath?.match(MONGO_ID_REGEX)) {
            this.$locationDataStore.fetchOne(this.locationPath).subscribe(location => {
                this.locationPath = locationSelectors.fullPath(location, this.$i18n.locale)
            })
        }
    }

    public deleteContainer() {
        if(this.featured?.id) {
            this.deleting = true
            this.$emit(DELETE_CARD, this.featured.id)
        }
    }

    @Watch('featured')
    onFeaturedChange() {
        this.isBeingDeleted = false
        this.deleting = false
        this.fillLocation()
    }
}
